export * from './delete-abschnitt.component';
export * from './delete-abschnitt.component.module';